import {pushNotification} from '@malt/joy-v2/src/js/notification';
import {fetchActiveCampaign, postDismiss, postAnswer} from './nps-api';
import {NpsDOM} from './nps-dom';
import NPS_TEMPLATE from '../../resources/handlebars/components/nps.hbs';

const DELAY = 2000;
const NOTIFICATION_DELAY = 500;

Hop.defineModule('nps', (root, param) => {
    let npsDOM = null;
    let answered = false;
    const identity = param.isFree ? 'freelance' : 'client';

    const handleSuccess = (msg) => {
        setTimeout(() => {
            pushNotification(msg, {level: 'success'});
        }, NOTIFICATION_DELAY);
    };

    const handleError = (err) => {
        if (window.captureException) {
            window.captureException(err);
        }
        setTimeout(() => {
            pushNotification(Hop.message('nps.feedback.error.label'), {level: 'error'});
        }, NOTIFICATION_DELAY);
    };

    const onCloseClick = () => {
        if (!answered) {
            postDismiss();
        }
        npsDOM.closePanel();
    };

    const onScoreClick = (e) => {
        const score = Number(e.target.getAttribute('data-score'));
        npsDOM.displayAnswer(score);
        postAnswer(score, npsDOM.getComment())
            .then(() => {
                answered = true;
                handleSuccess(Hop.message('nps.feedback.score.success.label'));
            })
            .catch((err) => {
                handleError(err);
            });
    };

    const onSubmitClick = () => {
        postAnswer(npsDOM.getScore(), npsDOM.getComment())
            .then(() => {
                npsDOM.closePanel();
                handleSuccess(Hop.message('nps.feedback.comment.success.label'));
            })
            .catch(() => {
                handleError();
            });
    };

    const onWindowHidden = () => {
        postDismiss();
        npsDOM.closePanel();
    };

    const trackHeap = (event) => {
        if (window.heap) {
            window.heap.track(event);
        }
    };

    /**
     * Do not display NPS popup on /appraisal because it could mislead some users
     * into commenting the mission in the NPS popup.
     */
    const parts = window.location.pathname.split('/');
    if (parts && parts.length >= 1 && parts[parts.length - 1] === 'appraisal') {
        return;
    }

    fetchActiveCampaign().then((displayNps) => {
        if (displayNps) {
            setTimeout(() => {
                root.innerHTML = NPS_TEMPLATE({
                    identity: identity,
                });
                npsDOM = new NpsDOM(root);
                npsDOM.addListeners(onCloseClick, onScoreClick, onSubmitClick, onWindowHidden);
                trackHeap('NpsBannerOpens');
            }, DELAY);
        }
    });

    return function destroy() {
        npsDOM.removeListeners();
    };
});
